export const ServiceTypes = {
  TABLE_AND_COLLECTION: 'table_collection',
  TABLE_ONLY: 'table',
  COLLECTION_ONLY: 'collection',
};



// WEBPACK FOOTER //
// ./src/utils/constants/venues.js